<template>
  <div class="news-page page">
    <BreadcrumbsComponent @back.prevent :links="links" />
    <div class="news-page__container">
      <div ref="newsList" class="news-page__content">
        <div v-if="showNews" class="news-page__items">
          <EntityCardComponent v-for="(item, i) in news.data" :key="i" :item="item" :is-news="true" />
        </div>
        <span v-else>Новости отсутствуют</span>
        <PaginationComponent
          v-if="showPagination"
          :page="page"
          :total="Math.ceil(news.paginatorInfo.total / first)"
          @change="paginate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "components/Pagination.vue";
import NEWS_PAGE from "@/graphql/pages/NewsPage.graphql";
import BreadcrumbsComponent from "components/BreadcrumbsComponent.vue";
import EntityCardComponent from "components/EntityCardComponent.vue";

export default {
  name: "NewsPage",
  async asyncData({ apollo, store }) {
    await apollo.defaultClient
      .query({
        query: NEWS_PAGE,
        variables: {
          first: store.state.isMobile ? 4 : 6,
        },
      })
      .then(({ data }) => {
        store.state.news_page.news = data.news_paginate;
        store.state.all_brands = data.brands || [];
        store.state.popular_brands = data.brands_paginate.data || [];
        store.state.categories = data.header_categories.data || [];
        store.state.pages = data.pages;
        store.state.marketplace = data.marketplace;
      });
  },
  data() {
    return {
      page: 1,
      first: this.$store.state.isMobile ? 4 : 6,
      paginateLoading: false,
    };
  },
  computed: {
    links() {
      return [{ title: "Блог" }];
    },
    news() {
      return this.$store.state.news_page.news;
    },
    showNews() {
      return this.news && this.news.data && this.news.data.length;
    },
    showPagination() {
      return this.showNews && Math.ceil(this.news.paginatorInfo.total / this.first) > 1;
    },
  },
  methods: {
    async paginate(page) {
      if (!this.paginateLoading) {
        this.page = page;
        this.paginateLoading = true;
        await this.load();
        this.scrollUp();
      }
    },
    async load() {
      await this.$apollo.provider.defaultClient
        .query({
          query: NEWS_PAGE,
          variables: {
            page: this.page,
            first: this.first,
          },
        })
        .then(({ data }) => {
          this.paginateLoading = false;
          this.$store.state.news_page.news = data.news_paginate;
          this.$store.state.categories = data.categories;
        })
        .catch(() => {
          this.filterLoading = false;
          this.paginateLoading = false;
        });
    },
    scrollUp() {
      if (window.scrollY > this.$refs.newsList.offsetTop) {
        window.scrollTo({ top: this.$refs.newsList.offsetTop });
      }
    },
  },
  components: {
    EntityCardComponent,
    BreadcrumbsComponent,
    PaginationComponent,
  },
  metaInfo: {
    title: "Блог",
  },
};
</script>

<style lang="stylus">
.news-page {
  width 100%
  display grid
  grid-gap 32px
  padding-top 32px
  padding-bottom 48px
  +below(420px) {
    grid-gap 16px
  }

  &__content {
    display grid
    grid-gap 32px
    width 100%
    max-width var(--main_width)
  }

  &__items {
    display flex
    flex-wrap wrap
    grid-gap 30px
  }

  &__container {
    display flex
    justify-content center
    padding: 0 15px;
  }
}
</style>
